import { generate } from 'shortid';
import { reflectKnot as reflectKnotWithAxis, FlipHorizontal, FlipVertical } from './KnotHelper';
import MathHelper from './MathHelper';
import SegmentHelper from './SegmentHelper';

export default class InternalLineHelper {
  static create(startWeld, endWeld, id = generate(), startHandle = { x: NaN, y: NaN }, endHandle = { x: NaN, y: NaN },
    startHandleInterpolated = true, endHandleInterpolated = true, knots = []) {
    return {
      id,
      startWeld,
      endWeld,
      startHandle,
      startHandleInterpolated,
      endHandle,
      endHandleInterpolated,
      knots,
    };
  }

  static reflect(internalLine, startWeldKnot, endtWeldKnot, axisStart, axisEnd) {
    const { knots, startHandle, endHandle } = internalLine;

    const reflectPoint = (point) => MathHelper.reflectPoint(point, axisStart, axisEnd);
    const reflectKnot = (knot) => reflectKnotWithAxis(knot, axisStart, axisEnd, false);

    // Absolute handles
    const absStartHandle = MathHelper.addPoints(startHandle, startWeldKnot);
    const absEndHandle = MathHelper.addPoints(endHandle, endtWeldKnot);

    return {
      ...internalLine,
      knots: knots.map((knot) => reflectKnot(knot)),
      startHandle: MathHelper.substractPoints(reflectPoint(absStartHandle), reflectKnot(startWeldKnot)),
      endHandle: MathHelper.substractPoints(reflectPoint(absEndHandle), reflectKnot(endtWeldKnot)),
    };
  }

  static getInternalLineWithFullKnots(internalLine, pieceKnots) {
    const { startWeld, endWeld, startHandle, startHandleInterpolated, endHandle, endHandleInterpolated, knots } = internalLine;

    const startWeldKnot = {
      ...pieceKnots.find((knot) => knot.id === startWeld),
      rH: startHandle,
      rHI: startHandleInterpolated,
      corner: true,
    };

    const endWeldKnot = {
      ...pieceKnots.find((knot) => knot.id === endWeld),
      lH: endHandle,
      lHI: endHandleInterpolated,
      corner: true,
    };

    const fullKnots = SegmentHelper.interpolateKnots([startWeldKnot, ...knots, endWeldKnot]);

    return {
      ...internalLine,
      fullKnots,
    };
  }

  static flipHorizontal(internalLine, xAxis) {
    return this.flip(internalLine, xAxis, 'x');
  }

  static flipVertical(internalLine, yAxis) {
    return this.flip(internalLine, yAxis, 'y');
  }

  static flip(internalLine, axis, dimension) {
    if (dimension !== 'x' && dimension !== 'y') throw Error('dimension should be "x" or "y".');

    const { endHandle, startHandle, knots } = internalLine;

    const flipRelativePoint = (point) => ({ ...point, [dimension]: -point[dimension] });

    return {
      ...internalLine,
      endHandle: flipRelativePoint(endHandle),
      startHandle: flipRelativePoint(startHandle),
      knots: knots.map((knot) => dimension === 'x' ? FlipHorizontal(knot, axis) : FlipVertical(knot, axis)),
    };
  }
}
